import { CxEvent } from '@spartacus/core';

export class Ga4GgProductSliderImageEvent extends CxEvent {
  event?: string;
  currency?: string;
  value?: number;
  file_name?: string;
  visitor_type?: string;
  items?: {
    item_id?: string;
    item_name?: string;
    price?: number;
  }[];
}
